import { gql } from '@apollo/client';

import type { Branding } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLVehicleModelsRequester {
  public getVehicleModels = (): Promise<Branding[]> => {
    return graphQLRequester
      .query<{ vehicleModels: Branding[] }>({
        query: gql`
          query vehicleModels {
            vehicleModels {
              brand
              model
              year
              type
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.vehicleModels);
  };
}

export default GraphQLVehicleModelsRequester;
